import { KommissionNotizArtenResponse } from '@/types/service-response'

export class CommissionNoteType {
  public constructor (
    readonly id: number,
    readonly name: string
  ) {}

  static createFromResponse (responseData: KommissionNotizArtenResponse[]): Array<CommissionNoteType> {
    let result: Array<CommissionNoteType> = []
    if (responseData) {
      result = responseData.map((item: KommissionNotizArtenResponse ) => {
        return new CommissionNoteType(
          item.ID,
          item.Bezeichnung ? item.Bezeichnung : ''
        )
      })
    }
    return result
  }
}
